import { Button, Grid, MenuItem } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { useMemo } from 'react'
import { metodoPrograma } from '../../../components/api'

const EdicaoTipoMovimentoEstoque = ({ dados, voltar }) => {
  const retornoTpMovimentoEstoque = useMemo(
    () => ({
      idTipoMovimento: dados?.[0] || undefined,
      dsNome: dados?.[1] || '',
      tpMovimentacao: dados?.[2] || '',
      dtExclusao: dados?.[3] || undefined,
    }),
    [dados],
  )

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={retornoTpMovimentoEstoque}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="tpMovimentacao"
                label="Tipo Movimentação"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                select
              >
                <MenuItem value={'E'}>Entrada</MenuItem>
                <MenuItem value={'S'}>Saída</MenuItem>
              </Field>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default EdicaoTipoMovimentoEstoque
